import React, { useEffect } from 'react';

import Col from 'react-bootstrap/Col';
import DateDesignerLeadFilter from './DateDesignerLeadFilter';
import ListView from '../shared/lists/ListView';
import MonthlyBusinessItem from './MonthlyBusinessItem';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import ExportButton from '../shared/buttons/ExportButton';

const MonthlyBusiness = ({
    items,
    filter,
    pageInfo,
    setFilter,
    setUrl
}) => {
    const postUrl = `/api/reports/monthlybusiness`;

    useEffect(() => setUrl(postUrl), []);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    content="Entered"
                    sort={pageInfo}
                    sortName="DateCreated"
                />
                <SortableTh
                    content="Customer"
                    sort={pageInfo}
                    sortName="CustomerName"
                />
                <SortableTh
                    content="Designer"
                    sort={pageInfo}
                    sortName="Designer"
                />
                <SortableTh
                    content="Install"
                    sort={pageInfo}
                    sortName="InstallDate"
                />
                <SortableTh
                    content="Total"
                    sort={pageInfo}
                    sortName="JobTotal"
                />
                <SortableTh
                    content="Deposit"
                    sort={pageInfo}
                    sortName="Deposit"
                />
                <SortableTh
                    content="Deposit Type"
                    sort={pageInfo}
                    sortName="PaymentType"
                />
                <SortableTh
                    content="Deposit Date"
                    sort={pageInfo}
                    sortName="DateDeposit"
                />
                <SortableTh
                    content="Balance"
                    sort={pageInfo}
                    sortName="BalanceDue"
                />
                <SortableTh
                    content="Paid"
                    sort={pageInfo}
                    sortName="PaidInFull"
                    width={55}
                />
                <SortableTh
                    content="Date Paid"
                    sort={pageInfo}
                    sortName="DateBalancePaid"
                />
                <SortableTh
                    content="Lead Source"
                    sort={pageInfo}
                    sortName="LeadSource"
                />
                <SortableTh
                    content="Sub Source"
                    sort={pageInfo}
                    sortName="SubLeadSource"
                />
                <th className="button-cell" style={{ width: "40px" }}>
                    <ExportButton
                        disabled={items === undefined || items === null || items.length === 0}
                        filter={filter}
                        url="/api/export/monthlybusiness"
                    />
                </th>
            </tr>
        </thead>
    );

    const listItems = items.map((item, index) =>
        <MonthlyBusinessItem
            item={item}
            key={item.id}
        />
    );

    return (
        <Row>
            <Col>
                <DateDesignerLeadFilter
                    filter={filter}
                    setFilter={setFilter}
                />
                <Row className='pb-5 mt-3'>
                    <Col className="small">
                        <ListView
                            animate={false}
                            canAdd={false}
                            items={listItems}
                            tableHead={tableHead}
                        />
                        <PagedListControl
                            {...pageInfo}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default MonthlyBusiness;